import React from 'react';

import { useTranslation } from '@lyearn/i18n';
import { AddBlock } from '@lyearn/molecules';
import { Loader, Stack } from '@lyearn/ui';
import { FilterOption } from '@/components/Filter/types';
import { Filter } from '@/components/FilterManager';
import { PeerFeedbackMindsetRatingInputType } from '@/types/schema';

import useCreateFeedbackRelatedMindsets from '../../../hooks/useCreateFeedbackRelatedMindsets';
import ReviewCardList from '../../ReviewCardList';
import { AddBlockStyles, MENU_LIST_OVERRIDES } from '../style';
import { SkillItemRenderer } from '../utils';

function RelatedMindsets({
  onChange,
  skillRatings,
  userId,
}: {
  onChange: (value: PeerFeedbackMindsetRatingInputType[]) => void;
  skillRatings: PeerFeedbackMindsetRatingInputType[];
  userId?: string;
}) {
  const { t } = useTranslation(['Feedback', 'Skills']);
  const {
    selectedSkillsState,
    filterGroups,
    fetching,
    skillRatingMap,
    onRatingChange,
    searchText,
    setSearchText,
    toggle,
    open,
    removeSkill,
    addSkill,
  } = useCreateFeedbackRelatedMindsets({
    userId,
    skillRatings,
    onChange,
  });

  return (
    <Stack direction="col">
      {fetching ? (
        <Stack alignItems="center" className="mb-16 flex-1" justifyContent="center">
          <Loader />
        </Stack>
      ) : (
        <ReviewCardList
          feedbackSkillData={skillRatingMap}
          isMindset={true}
          removeSkill={removeSkill}
          skills={selectedSkillsState || []}
          onChange={onRatingChange}
        />
      )}
      <Filter
        asyncOptions={{
          search: {
            placeholder: t('Skills:Mindset.SearchSkills'),
            value: searchText,
            onChange: setSearchText,
          },
        }}
        emptyLabel={
          userId ? t('Feedback:NoMindsetsDesc') : t('Feedback:NoUserSelectedMindsetsDesc')
        }
        groups={filterGroups}
        itemRenderer={SkillItemRenderer}
        open={open}
        overrides={MENU_LIST_OVERRIDES}
        showActionButtons={false}
        value={(selectedSkillsState || []) as FilterOption[]}
        onChange={addSkill}
        onClose={toggle}
        onToggle={toggle}>
        <AddBlock
          className={AddBlockStyles}
          title={t(`Feedback:CreateFeedback.Mindset.AddSkills`)}
        />
      </Filter>
    </Stack>
  );
}

export default RelatedMindsets;
